import { Suspense } from "react"
import { Navigate, Outlet } from "react-router-dom"
import ProtectedRoute from "./protected-route"
import { LoadingAnimation } from "@/components/loading-animation/loading-animation.tsx"
import useFarmHasMammals from "@/features/farm/hooks/use-farm-has-mammals.ts"
import { NOT_ENABLED_SCREEN } from "@/features/home/routes/route-list"
import useFarmPermissions from "@/features/permissions/hooks/use-farm-permissions.ts"
import { LOGIN_SCREEN } from "@/features/register-login/routes/route-list.ts"
import { useAuth } from "@/hooks/use-auth.ts"

export function FarmModuleEnabled() {
  const isMammal = useFarmHasMammals()
  return isMammal ? <Outlet /> : <Navigate to={"/home"} replace />
}

export function BeeModuleEnabled() {
  const { permissions } = useFarmPermissions()
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <ProtectedRoute
        redirectRoute={NOT_ENABLED_SCREEN}
        condition={permissions?.bee_module}
      />
    </Suspense>
  )
}

export function BirdsModuleEnabled() {
  const { permissions } = useFarmPermissions()
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <ProtectedRoute
        redirectRoute={NOT_ENABLED_SCREEN}
        condition={permissions?.bird_module}
      />
    </Suspense>
  )
}

export function ParcelsModuleEnabled() {
  const { permissions } = useFarmPermissions()
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <ProtectedRoute
        redirectRoute={NOT_ENABLED_SCREEN}
        condition={permissions?.parcels_module}
      />
    </Suspense>
  )
}

export function FinanceJournalEnabled() {
  const { permissions } = useFarmPermissions()
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <ProtectedRoute
        redirectRoute={NOT_ENABLED_SCREEN}
        condition={permissions?.finance_journal_module}
      />
    </Suspense>
  )
}

export function AIAssistantEnabled() {
  const { permissions } = useFarmPermissions()
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <ProtectedRoute
        redirectRoute={NOT_ENABLED_SCREEN}
        condition={permissions?.ai_assistant_module}
      />
    </Suspense>
  )
}

export function GestationalCalendarEnabled() {
  const { permissions } = useFarmPermissions()
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <ProtectedRoute
        redirectRoute={NOT_ENABLED_SCREEN}
        condition={permissions?.gestational_calendar_module}
      />
    </Suspense>
  )
}

export function AuthenticatedRoutes() {
  const auth = useAuth()
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <ProtectedRoute
        redirectRoute={LOGIN_SCREEN}
        condition={Boolean(auth.token && auth.farmId)}
      />
    </Suspense>
  )
}

export function OnBoardingRoutes() {
  const auth = useAuth()
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <ProtectedRoute
        redirectRoute={LOGIN_SCREEN}
        condition={Boolean(auth.token && !auth.farmId)}
      />
    </Suspense>
  )
}
